export default __webpack_public_path__ + "static/media/mobileMinion.334cbf86.svg";